import React, { ReactNode } from 'react'
import SidePanelFramework from '@bt-react/components/SidePanelFramework'
import Icon, { IconType } from '@bt-react/components/Icon'
import AnnouncementsAlert from '@bt-react/components/Announcements/AnnouncementsAlert'
import AnnouncementsCharacterCounter from '@bt-react/components/Announcements/AnnouncementsCharacterCounter'
import AnnouncementsSuccess from '@bt-react/components/Announcements/AnnouncementsSuccess'
import { AnnouncementsPanelProps, AnnouncementsPanelState } from './types'
import style from './AnnouncementsPanel.module.scss'

class AnnouncementsPanel extends React.Component<AnnouncementsPanelProps, AnnouncementsPanelState> {

  state = {
    message: ''
  }

  componentDidUpdate (prevProps: AnnouncementsPanelProps) {

    if (prevProps.audienceMessage !== '' && this.props.audienceMessage === '') this.setState({ message: '' })

  }

  handleSubmitMessage = (message) => this.setState({ message })
  handleConfirmMessage = () => this.props.onSubmit(this.props.roomname, this.state.message)
  handleCancelMessage = () => this.setState({ message: '' })
  handleClearMessage = () => {

    this.setState({ message: '' })
    this.props.onClear(this.props.roomname)

  }

  getContent = (): ReactNode => {

    if (this.props.audienceMessage) {

      return <AnnouncementsSuccess
        announcementText={this.props.audienceMessage}
        onClick={this.handleClearMessage}
      />

    }

    if (!this.state.message) {

      return <div>
        <AnnouncementsCharacterCounter disable={this.props.disabled} handleSubmit={this.handleSubmitMessage} />
        {
          this.props.disabled &&
          <div className={ style['announcements-alerttext-container']} >
            <span>
              <Icon name={ IconType.iconName.infoCircle } colour={IconType.colour.task} className={ style['info-circle'] }/>
            </span>
            <span>Live audience announcements only available from 5 minutes before scheduled start time</span>
          </div>
        }
      </div>

    }
    else {

      return <AnnouncementsAlert
        announcementText={this.state.message}
        onConfirm={this.handleConfirmMessage}
        onCancel={this.handleCancelMessage}
      />

    }

  }

  render () {

    const addPadding = !this.state.message && !this.props.audienceMessage

    return <SidePanelFramework
      icon={IconType.iconName.commentAltExclamation}
      title='Announcements'
      dataBdd='side-panel-announcements'
      content={this.getContent()}
      contentPadding={addPadding}
    />

  }

}

export default AnnouncementsPanel
